import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createSuper";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Base from '../../../base';
import Vue from 'vue';
import Gikam from '../../../../core/gikam-core';
var defaultOptions = {
  id: void 0,
  showScheme: false,
  indexSetting: false,
  renderTo: void 0,
  onAfterClose: Gikam.emptyFunction
};

var IndexPanelConfig = /*#__PURE__*/function (_Base) {
  _inherits(IndexPanelConfig, _Base);

  var _super = _createSuper(IndexPanelConfig);

  function IndexPanelConfig(options) {
    var _this2;

    _classCallCheck(this, IndexPanelConfig);

    _this2 = _super.call(this, options);

    _this2.initialize(options, defaultOptions).init(options);

    return _this2;
  }

  _createClass(IndexPanelConfig, [{
    key: "createModel",
    value: function createModel() {
      var h = this.$createElement;

      var _this = this;

      this.model = new Vue({
        el: Gikam.createDom('div', this.options.renderTo),
        components: {
          indexPanelConfig: function indexPanelConfig() {
            return import('@/gikam/js/components/huge/indexPanelConfig/vue/indexPanelConfig.vue');
          }
        },
        mounted: function mounted() {
          _this.bindInstance(this.$el);
        },
        render: function render() {
          var h = arguments[0];
          return h("indexPanelConfig", {
            "ref": "indexPanel",
            "attrs": {
              "options": _this.options
            }
          });
        }
      });
    }
    /**
     * @description 清空配置数据
     * @public
     * @memberof indexPanelConfig
     */

  }, {
    key: "clear",
    value: function clear() {
      this.model.$refs.indexPanel.clearPanelData();
    }
    /**
     * @description 刷新配置数据
     * @public
     * @memberof indexPanelConfig
     */

  }, {
    key: "refresh",
    value: function refresh(param) {
      this.model.$refs.indexPanel.getPanelConfig(param);
    }
  }, {
    key: "init",
    value: function init() {
      this.createModel();
    }
  }]);

  return IndexPanelConfig;
}(Base);

export { IndexPanelConfig as default };